(function(){
  var header = document.querySelector('[data-vv-header]');
  if(!header) return;
  var hoverable = window.matchMedia('(hover:hover)').matches;
  var desktop = window.matchMedia('(min-width:1024px)').matches;
  var hoverIntentDelay = 140;
  var hoverCloseDelay = 180;

  /* ---- desktop sticky header ---- */
  var navRow = header.querySelector('[data-vv-navrow]');
  if(navRow && desktop){
    new IntersectionObserver(function(entries){
      var entry = entries[0];
      header.classList.toggle('is-desktop-stuck', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
    }).observe(navRow);
  }

  function bindHoverMenu(root, btn, panel){
    if(!btn || !panel) return;
    var openTimer, closeTimer;
    function clearMenuTimers(){ clearTimeout(openTimer); clearTimeout(closeTimer); }
    function setMenuOpen(open){
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(panel.hasAttribute('aria-hidden')) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    function openMenu(){
      clearMenuTimers();
      setMenuOpen(true);
    }
    function closeMenu(){
      clearMenuTimers();
      setMenuOpen(false);
    }
    if(hoverable){
      root.addEventListener('mouseenter', function(){
        clearMenuTimers();
        if(!root.classList.contains('is-open')) openTimer = setTimeout(openMenu, hoverIntentDelay);
      });
      root.addEventListener('mouseleave', function(){
        clearMenuTimers();
        closeTimer = setTimeout(closeMenu, hoverCloseDelay);
      });
      panel.addEventListener('mouseenter', clearMenuTimers);
      panel.addEventListener('mouseleave', function(){
        clearMenuTimers();
        closeTimer = setTimeout(closeMenu, hoverCloseDelay);
      });
    }
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      root.classList.contains('is-open') ? closeMenu() : openMenu();
    });
    root.addEventListener('focusout', function(e){ if(!root.contains(e.relatedTarget)) closeMenu(); });
    document.addEventListener('click', function(e){ if(!root.contains(e.target)) closeMenu(); });
    return { close: closeMenu };
  }

  /* ---- categories mega menu: hover intent, close grace, and rail panels ---- */
  header.querySelectorAll('[data-vv-cats]').forEach(function(cats){
    var btn = cats.querySelector('.vv-cats__btn');
    var mega = cats.querySelector('.vv-mega');
    var tabs = cats.querySelectorAll('[data-vv-tab]'), panels = cats.querySelectorAll('[data-vv-panel]');
    var activateTimer;
    bindHoverMenu(cats, btn, mega);
    tabs.forEach(function(tab){
      function activate(){
        var i = tab.getAttribute('data-vv-tab');
        tabs.forEach(function(x){ x.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-vv-panel') === i); });
        tab.classList.add('is-active');
      }
      tab.addEventListener('mouseenter', function(){
        clearTimeout(activateTimer);
        activateTimer = setTimeout(activate, hoverIntentDelay);
      });
      tab.addEventListener('mouseleave', function(){ clearTimeout(activateTimer); });
      tab.addEventListener('focus', function(){ clearTimeout(activateTimer); activate(); });
    });
    cats.addEventListener('mouseleave', function(){ clearTimeout(activateTimer); });
  });

  /* ---- country selector ---- */
  var country = header.querySelector('[data-vv-country]');
  if(country){
    var countryToggle = country.querySelector('[data-vv-country-toggle]');
    var countryController = bindHoverMenu(country, countryToggle, country.querySelector('[data-vv-country-menu]'));
    if(countryController){
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && country.classList.contains('is-open')){
          countryController.close();
          countryToggle.focus();
        }
      });
      if(desktop) window.addEventListener('scroll', function(){
        if(country.classList.contains('is-open')) countryController.close();
      }, {passive:true});
    }
  }

  /* ---- primary dropdowns (fixed panels) ---- */
  var drops = [].slice.call(header.querySelectorAll('[data-vv-drop]'));
  function closeAllDrops(except){ drops.forEach(function(d){ if(d !== except) d.classList.remove('is-open'); }); }
  drops.forEach(function(drop){
    var toggle = drop.querySelector('[data-vv-drop-toggle]');
    var panel = drop.querySelector('[data-vv-drop-panel]');
    if(!toggle || !panel) return;
    var openTimer, closeTimer;
    function position(){
      var r = toggle.getBoundingClientRect();
      panel.style.top = Math.round(r.bottom + 6) + 'px';
      var pw = panel.offsetWidth || 240, left = r.left;
      if(left + pw > window.innerWidth - 12) left = window.innerWidth - pw - 12;
      if(left < 12) left = 12;
      panel.style.left = Math.round(left) + 'px';
    }
    function clearTimers(){ clearTimeout(openTimer); clearTimeout(closeTimer); }
    function open(){ clearTimers(); closeAllDrops(drop); position(); drop.classList.add('is-open'); }
    function close(){ clearTimers(); drop.classList.remove('is-open'); }
    if(hoverable){
      drop.addEventListener('mouseenter', function(){
        clearTimers();
        openTimer = setTimeout(function(){ if(drop.matches(':hover')) open(); }, hoverIntentDelay);
      });
      drop.addEventListener('mouseleave', function(){
        clearTimers();
        closeTimer = setTimeout(close, hoverCloseDelay);
      });
      panel.addEventListener('mouseenter', clearTimers);
      panel.addEventListener('mouseleave', function(){
        clearTimers();
        closeTimer = setTimeout(close, hoverCloseDelay);
      });
    }
    toggle.addEventListener('click', function(e){ if(!hoverable){ e.preventDefault(); drop.classList.contains('is-open') ? close() : open(); } });
  });
  if(desktop){
    window.addEventListener('scroll', function(){ closeAllDrops(null); }, {passive:true});
  }
  document.addEventListener('click', function(e){
    drops.forEach(function(d){ if(!d.contains(e.target)) d.classList.remove('is-open'); });
  });

  /* ---- horizontal scroll strip (arrows + fades) ---- */
  var scrollWraps = [].slice.call(header.querySelectorAll('[data-vv-links-scroll]'));
  function updateScrollState(wrap){
    var box = wrap.parentElement;
    var max = wrap.scrollWidth - wrap.clientWidth - 1;
    box.classList.toggle('can-l', wrap.scrollLeft > 2);
    box.classList.toggle('can-r', wrap.scrollLeft < max);
  }
  function updateAllScrollStates(){ scrollWraps.forEach(updateScrollState); }
  scrollWraps.forEach(function(wrap){
    wrap.addEventListener('scroll', function(){ updateScrollState(wrap); }, {passive:true});
    var box = wrap.parentElement;
    box.querySelectorAll('[data-vv-scroll]').forEach(function(btn){ btn.addEventListener('click', function(){ wrap.scrollBy({ left: parseInt(btn.getAttribute('data-vv-scroll'),10) * 320, behavior:'smooth' }); }); });
    updateScrollState(wrap);
  });
  window.addEventListener('resize', updateAllScrollStates, {passive:true});
  if(document.readyState !== 'complete') window.addEventListener('load', updateAllScrollStates, {once:true});

  /* ---- full-screen mobile menu ---- */
  var mmenu = header.querySelector('[data-vv-mmenu]');
  var mainRow = header.querySelector('.vv-main');
  var mmToggles = header.querySelectorAll('[data-vv-mm-toggle]');
  var menuViews = mmenu ? [].slice.call(mmenu.querySelectorAll('[data-vv-menu-view]')) : [];
  function showDrillView(target, shouldFocus, backwards){
    var activeView = menuViews.find(function(view){ return view.getAttribute('data-vv-menu-view') === target; });
    if(!activeView) return;
    var currentView = menuViews.find(function(view){ return view.classList.contains('is-active'); });
    if(currentView && currentView !== activeView){
      currentView.classList.remove('is-active');
      currentView.classList.toggle('is-behind', !backwards);
    }
    activeView.classList.remove('is-behind');
    activeView.classList.add('is-active');
    menuViews.forEach(function(view){
      view.setAttribute('aria-hidden', view === activeView ? 'false' : 'true');
    });
    activeView.scrollTop = 0;
    if(shouldFocus){
      var focusTarget = activeView.querySelector('button, a');
      if(focusTarget) focusTarget.focus({preventScroll:true});
    }
  }
  function resetDrill(){
    menuViews.forEach(function(view){
      view.classList.remove('is-active', 'is-behind');
      view.setAttribute('aria-hidden', 'true');
      view.scrollTop = 0;
    });
    showDrillView('root', false, false);
  }
  function mmOpen(){
    if(mainRow) document.documentElement.style.setProperty('--vv-mm-top', mainRow.offsetHeight + 'px');
    resetDrill();
    document.body.classList.add('vv-mm-open','vv-lock');
    mmToggles.forEach(function(b){ b.setAttribute('aria-expanded','true'); b.setAttribute('aria-label','Close menu'); });
    if(mmenu) mmenu.setAttribute('aria-hidden','false');
  }
  function mmClose(){
    document.body.classList.remove('vv-mm-open','vv-lock');
    mmToggles.forEach(function(b){ b.setAttribute('aria-expanded','false'); b.setAttribute('aria-label','Open menu'); });
    if(mmenu) mmenu.setAttribute('aria-hidden','true');
    resetDrill();
  }
  function mmToggle(){ document.body.classList.contains('vv-mm-open') ? mmClose() : mmOpen(); }
  mmToggles.forEach(function(b){ b.addEventListener('click', mmToggle); });
  if(mmenu){
    mmenu.addEventListener('click', function(e){
      var drillTrigger = e.target.closest('[data-vv-drill-target]');
      if(drillTrigger){
        e.preventDefault();
        showDrillView(drillTrigger.getAttribute('data-vv-drill-target'), true, drillTrigger.classList.contains('vv-mmenu__back'));
        return;
      }
      var a = e.target.closest('a');
      if(a) mmClose();
    });
  }
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && document.body.classList.contains('vv-mm-open')) mmClose(); });

  /* ---- mobile accordions (animated) ---- */
  header.querySelectorAll('[data-vv-macc-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var acc = btn.closest('[data-vv-macc]');
      if(!acc) return;
      var open = acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
